/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { mFIGetPaymentEstimatesAsync } from './progressive-proxy-files/ProgressiveDataActionExtension.g';
import { IMFIGetPaymentEstimateResponse, IPaymentEstimateResponse } from './progressive-proxy-files/ProgressiveDataServiceEntities.g';

/**
 * ProgressiveGetPaymentEstimate Input Action
 */
export class ProgressiveGetPaymentEstimateInput implements Msdyn365.IActionInput {
    public invoiceAmount?: number;
    public state?: string;
    public tenderType?: string;
    public checkoutType?: string;
    constructor(invoiceAmount?: number, state?: string, tenderType?: string, checkoutType?: string) {
        this.invoiceAmount = invoiceAmount;
        this.state = state;
        this.tenderType = tenderType;
        this.checkoutType =  checkoutType;
    }
    public getCacheKey = () => `ProgressiveGetPaymentEstimate`;
    public getCacheObjectType = () => 'ProgressiveGetPaymentEstimate';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * ProgressiveGetPaymentEstimate: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ProgressiveGetPaymentEstimateInput();
};

/**
 * ProgressiveGetPaymentEstimate: Use this function to call your action and process the results as needed
 */
async function getProgressiveEstimate(
    input: ProgressiveGetPaymentEstimateInput,
    ctx: Msdyn365.IActionContext
): Promise<IPaymentEstimateResponse | null> {
    const getLeaseObj = {
        InvoiceAmount: input.invoiceAmount ?? 0,
        Deposit: 0,
        TenderType: input.tenderType,
        TransactionType: input.checkoutType,
        PaymentFrequency: 'biweekly',
        State: input.state
    };

    try {
      const response: IMFIGetPaymentEstimateResponse = await mFIGetPaymentEstimatesAsync({ callerContext: ctx }, getLeaseObj);
      if(response.PaymentEstimates) {
        return response.PaymentEstimates;
      } else {
        return null;
      }
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaymentEstimateResponse>>getProgressiveEstimate,
    id: 'ProgressiveGetPaymentEstimate',
    input: createInput
});
